import { getRecoil, setRecoil } from "recoil-nexus";
import messagesState from "../../atoms/messages";
import participantsState from "../../atoms/participants";
import roomDetailState, { PickType } from "../../atoms/roomDetail";
import userDetailsState from "../../atoms/userDetails";
import emitGetMyInfo from "../emits/getMyInfo";
import { socket } from "../index";
import { Message, MessageType, SystemMessageType, UserDetail } from "../type";

interface ListenReceiveMessagePayload {
  roomId: string,
  message: Message,
  userDetail: UserDetail,
}

const listenReceiveMessage = () => {
  socket?.on('RECEIVE_MESSAGE', (payload: ListenReceiveMessagePayload) => {
    const participants = getRecoil(participantsState);
    if (payload.roomId !== participants.roomId) {
      return;
    }

    const messages = getRecoil(messagesState);

    if (payload.message.messageType === MessageType.PLANE) {
      setRecoil(messagesState, {
        ...messages,
        messages: [...messages.messages, payload.message],
      });
    } else if (payload.message.messageType === MessageType.SYSTEM) {
      const contents = payload.message.contents as { 
        systemMessageType: SystemMessageType;
        pick: PickType;
      };
      if (contents.systemMessageType === SystemMessageType.CLEAN_ROOM) {
        // Clean room
        setRecoil(messagesState, {
          ...messages,
          messages: [payload.message],
        });
      } else if (contents.systemMessageType === SystemMessageType.GIFT_BULLET) {
        emitGetMyInfo();
        setRecoil(messagesState, {
          ...messages,
          messages: [
            ...messages.messages, 
            payload.message
          ],
        });
      } else if (contents.systemMessageType === SystemMessageType.PICK) {
        setRecoil(messagesState, {
          ...messages,
          messages: [
            ...messages.messages, 
            payload.message
          ],
        });
      } else if (contents.systemMessageType === SystemMessageType.PICK_RESULT) {
        // TODO: PROCESS
        const roomDetil = getRecoil(roomDetailState);
        const pickHistory = roomDetil.pickHistory;
        const pickHistoryItem = pickHistory.shift();
        if (pickHistoryItem != null) {
          pickHistoryItem.result = contents.pick;
          pickHistory.unshift(pickHistoryItem);
        }

        setRecoil(roomDetailState, {
          ...roomDetil,
          pickHistory,
        });

        setRecoil(messagesState, {
          ...messages,
          messages: [
            ...messages.messages, 
            payload.message
          ],
        });
      }
    }

    const userDetails = getRecoil(userDetailsState);

    const newUserDetails = new Map(userDetails);
    if (payload.userDetail != null) {
      newUserDetails.set(payload.userDetail.id, payload.userDetail);
    }
    setRecoil(userDetailsState, newUserDetails);
  });
}

export default listenReceiveMessage;